import { useMutation } from '@apollo/client';
import {
  Arrange,
  Button,
  Container,
  IconButton,
  SvgClose,
  Text,
} from '@loomhq/lens';
import React from 'react';

import { WORKSPACE_SUGGESTION_CLICK } from 'constants/events';
import { REQUEST_STATUSES } from 'constants/workspaceJoinRequests';
import * as analytics from 'utilities/analytics';
import { getCloudfrontURI } from 'utilities/avatar';
import { useSuggestedWorkspaceWorkspaceSwitcherDismissalState } from 'utilities/localStorage/suggestedWorkspace';
import RequestToJoinWorkspace from 'utilities/RequestToJoinWorkspace.graphql';

import { REQUEST_TO_JOIN_WORKSPACE_AUTOJOINED } from '../../../../../../../shared/constants/organizationInvitations';

import FacePile from 'components/face-pile';

export default function SuggestedWorkspace({ suggestedWorkspaceData }) {
  const [requestToJoinWorkspace] = useMutation(RequestToJoinWorkspace);
  const [suggestionDismissed, dismissSuggestion] =
    useSuggestedWorkspaceWorkspaceSwitcherDismissalState();

  async function onRequestClick() {
    const { data } = await requestToJoinWorkspace({
      variables: { workspaceId: workspace.id },
    });

    analytics.track(WORKSPACE_SUGGESTION_CLICK, {
      source: 'workspace-selector',
      status: data.result.status,
      suggestedWorkspaceId: workspace.id,
    });

    if (data.result.status === REQUEST_TO_JOIN_WORKSPACE_AUTOJOINED) {
      // The user's default workspace has changed, so let's take them to their new workspace
      window.location.href = '/';
    }
  }

  const { workspace, requestStatus, hasPendingInvitation } =
    suggestedWorkspaceData.result;
  const memberCount = workspace.counts?.users?.total_active_workspace_users;

  if (
    requestStatus === REQUEST_STATUSES.APPROVED ||
    hasPendingInvitation ||
    suggestionDismissed
  ) {
    return null;
  }

  return (
    <Container backgroundColor="highlight" padding="medium">
      <Arrange gap="medium" justifyContent="space-between">
        <Arrange autoFlow="row" gap="small">
          <Text fontWeight="bold">
            {suggestedWorkspaceData.result.workspace.name}
          </Text>
          <Arrange gap="small">
            <FacePile
              userData={suggestedWorkspaceData.result.workspace.members.nodes.map(
                ({ user }) => ({
                  name: user.first_name,
                  avatarSrc: getCloudfrontURI(user.avatars[0].thumb),
                })
              )}
              maxImages={4}
              alignment="left"
              avatarSize={3}
            />
            {memberCount && memberCount > 4 && (
              <Text size="small" color="bodyDimmed">
                +{memberCount - 4}
              </Text>
            )}
          </Arrange>
        </Arrange>
        <div>
          {requestStatus === REQUEST_STATUSES.PENDING ? (
            <Text color="bodyDimmed" fontWeight="medium">
              Pending
            </Text>
          ) : (
            <Arrange gap="xsmall">
              <Button onClick={onRequestClick} variant="primary" size="small">
                Join
              </Button>
              <IconButton
                altText="Dismiss"
                onClick={() => dismissSuggestion()}
                icon={<SvgClose />}
                size="small"
              />
            </Arrange>
          )}
        </div>
      </Arrange>
    </Container>
  );
}
